/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component } from 'react'
import { Dialog, Button as FlatButton } from '@mineral/core'
import ComponentInfo from './../../resources/ComponentInfo'
import Resource from './Resource'

export default class ComponentInfoDialog extends Component {
  handleClose() {
    this.props.handleClose(false)
  }

  render() {
    const actions = [
      <FlatButton
        variant="text"
        //Close
        children= {Resource.get('Close')}
        color ="primary"
        onClick={this.handleClose.bind(this)}
      />,
    ]
    //Client:
    const ClientLabel = Resource.get('Client:')
    //Branch:
    const BranchLabel = Resource.get('Branch:')
    //Rev:
    const RevLabel = Resource.get('Rev:')
    //Date:
    const DateLabel = Resource.get('Date:')
    //Server/API:
    const ServerApiLabel = Resource.get('Server/API:')
    //

    return (
      <Dialog actions={actions} open={this.props.isVisible} modal={false}>
        <div style={{ display: 'flex', fontFamily: 'monospace' }}>
          <span
            style={{ width: '100px', marginRight: '10px', textAlign: 'right' }}>
            {ClientLabel}
          </span>
          <span>
            <b>
              {ComponentInfo.COMPONENT_NAME} v{ComponentInfo.VERSION}.{ComponentInfo.BUILD_NUMBER}
            </b>
            <br />
            {BranchLabel} {ComponentInfo.BRANCH}
            <br />
            {RevLabel} {ComponentInfo.COMMIT_ID}
            <br />
            {DateLabel} {ComponentInfo.BUILD_DATE}
          </span>
        </div>
        <div
          style={{
            display: 'flex',
            fontFamily: 'monospace',
            marginTop: '10px',
          }}>
          <span
            style={{ width: '100px', marginRight: '10px', textAlign: 'right' }}>
          {ServerApiLabel}
          </span>
          <span>
            <b>
              {this.props.apiInfo.componentName} v{this.props.apiInfo.version}.{this.props.apiInfo.buildNumber}
            </b>
            <br />
            {BranchLabel} {this.props.apiInfo.branch}
            <br />
            {RevLabel} {this.props.apiInfo.commitId}
            <br />
            {DateLabel} {this.props.apiInfo.buildDate}
            <br />
          </span>
        </div>
      </Dialog>
    )
  }
}
